import React, { useState, useEffect } from 'react';
const logo = '/logo.png';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = [
    { label: 'Accueil', href: '#hero' },
    { label: 'Comment ça marche', href: '#process' },
    { label: 'Nos verticales', href: '#verticals' },
    { label: 'Tarifs', href: '#pricing' },
    { label: 'Portfolio', href: '#portfolio' },
    { label: 'Contact', href: '#contact' },
  ];

  return (
    <nav style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
      background: scrolled ? 'rgba(10,10,15,0.92)' : 'transparent',
      backdropFilter: scrolled ? 'blur(16px)' : 'none',
      borderBottom: scrolled ? '1px solid rgba(124,58,237,0.12)' : 'none',
      transition: 'all 0.3s ease',
      padding: '0 2rem',
    }}>
      <div style={{
        maxWidth: 1200, margin: '0 auto',
        display: 'flex', alignItems: 'center',
        justifyContent: 'space-between',
        height: 68,
      }}>
        {/* Logo */}
        <a href="#hero" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
          <img src={logo} alt="SoftyPusher" style={{ height: 36, width: 36, borderRadius: 8 }} />
          <span style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontWeight: 700, fontSize: 18, color: '#fff' }}>
            Softy<span style={{ color: '#A78BFA' }}>Pusher</span>
          </span>
        </a>

        {/* Desktop links */}
        <div style={{ display: 'flex', gap: '2rem', alignItems: 'center' }} className="desktop-nav">
          {links.map(l => (
            <a key={l.href} href={l.href} style={{
              color: '#c4c4d0', textDecoration: 'none',
              fontSize: 14, fontWeight: 400,
              transition: 'color 0.2s',
            }}
              onMouseEnter={e => e.target.style.color = '#fff'}
              onMouseLeave={e => e.target.style.color = '#c4c4d0'}
            >{l.label}</a>
          ))}
        </div>

        {/* CTA */}
  <a href="#contact" className="nav-cta" style={{
  background: '#7C3AED', color: '#fff',
  padding: '10px 20px', borderRadius: 8,
  textDecoration: 'none', fontSize: 14,
  fontWeight: 600, fontFamily: 'Plus Jakarta Sans, sans-serif',
  transition: 'background 0.2s',
  whiteSpace: 'nowrap',
}}
  onMouseEnter={e => e.target.style.background = '#6D28D9'}
  onMouseLeave={e => e.target.style.background = '#7C3AED'}

>Démarrer un projet</a>
        {/* Mobile burger */}
        <button onClick={() => setOpen(!open)} style={{
          display: 'none', background: 'none', border: 'none',
          color: '#fff', fontSize: 24, cursor: 'pointer',
        }} className="burger">☰</button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div style={{
          background: '#111118', padding: '1rem 2rem',
          borderTop: '1px solid rgba(124,58,237,0.15)',
        }}>
          {links.map(l => (
            <a key={l.href} href={l.href}
              onClick={() => setOpen(false)}
              style={{
                display: 'block', color: '#c4c4d0',
                textDecoration: 'none', padding: '0.75rem 0',
                borderBottom: '1px solid rgba(255,255,255,0.05)',
                fontSize: 15,
              }}>{l.label}</a>
          ))}
        </div>
      )}

      <style>{`
  @media (max-width: 768px) {
    .desktop-nav { display: none !important; }
    .burger { display: block !important; }
    .nav-cta { display: none !important; }
  }
`}</style>
    </nav>
  );
}
